import { render, staticRenderFns } from "./RemindingStatus.vue?vue&type=template&id=376329d5&"
import script from "./RemindingStatus.vue?vue&type=script&lang=js&"
export * from "./RemindingStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports